"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bcgExpertStatus = exports.bcgExpertSubmit = exports.updateGo30Information = exports.getScreeningAnswersHtml = exports.updateScreeningV2Responses = exports.getHCPAdditionalInfo = exports.saveHCPAdditionalInfo = exports.sendGenericLinks = exports.sendIndividualLink = exports.updateEpl = exports.createFollowUpEpl = exports.convertCurrency = exports.sendRejectionEmail = exports.sendGo30Email = exports.sendExtractEplEmail = exports.recalculateMargin = exports.getLoggedEvents = exports.setStatusForEpls = exports.setSegmentForEpls = exports.rearchiveRecording = exports.getRecordingsFromEplId = exports.getRecordingsFromEplHash = exports.fetchRecordingsFromEplId = exports.bulkInvite = exports.bulkValidate = exports.bulkCreate = exports.inviteToProject = exports.getExternLinks = exports.getExternLink = exports.getEplStatuses = exports.remove = exports.invokeAISync = exports.getZoomRecordingCount = exports.getHiddenExperienceFields = exports.getHiddenExperiences = exports.getEmployeeSubmitted = exports.saveScheduleSettings = exports.updateDeliveredByInBatch = exports.updateDeliveredBy = exports.autosave = exports.save = exports.get = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var pick_1 = tslib_1.__importDefault(require("lodash/pick"));
var base = '/api/expert-project-link';
/**
 * Will make sure only relevant data is sent to server.
 *
 * @param {Object} rawEplFormData
 */
function cleanupData(rawEplFormData) {
    var formData = (0, pick_1.default)(rawEplFormData, [
        'industryExpertise',
        'screening',
        'relevantExperienceId',
        'additionalExperienceId',
        'overwriteExpertIndustryExpertise',
        'honorariumCurrencyId',
        'honorarium',
        'free',
        'v2Screening',
        'feeCurrencyId',
        'fee',
        'credits',
        'pricingId',
        'expertAvailability',
        'hiddenExperienceIds',
        'cvId',
        'fieldsHiddenToExpert',
        'experiencesHiddenToExpert',
        'geographicalRateCard',
        'rateMultiplier',
    ]);
    if (formData.honorarium === '') {
        formData.honorarium = null;
    }
    return formData;
}
function get(eplId) {
    return api_1.default.get("".concat(base, "/").concat(eplId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.get = get;
function save(eplId, eplFormData, hiddenExperienceIds, fieldsHiddenToExpert, experiencesHiddenToExpert) {
    if (fieldsHiddenToExpert === void 0) { fieldsHiddenToExpert = null; }
    if (experiencesHiddenToExpert === void 0) { experiencesHiddenToExpert = null; }
    var eplData = cleanupData(tslib_1.__assign(tslib_1.__assign({}, eplFormData), { hiddenExperienceIds: hiddenExperienceIds, fieldsHiddenToExpert: fieldsHiddenToExpert, experiencesHiddenToExpert: experiencesHiddenToExpert }));
    return api_1.default.put("".concat(base, "/").concat(eplId, "/v2"), eplData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.save = save;
function autosave(eplId, eplData) {
    return api_1.default.put("".concat(base, "/").concat(eplId, "/expanded"), eplData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.autosave = autosave;
function updateDeliveredBy(eplId, payload) {
    return api_1.default.put("".concat(base, "/").concat(eplId, "/delivered-by"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateDeliveredBy = updateDeliveredBy;
function updateDeliveredByInBatch(eplIds, deliveredBy) {
    return api_1.default.put("".concat(base, "/delivered-by-in-batch"), { eplIds: eplIds, deliveredBy: deliveredBy }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateDeliveredByInBatch = updateDeliveredByInBatch;
function saveScheduleSettings(eplId, scheduleData) {
    return api_1.default.post("".concat(base, "/").concat(eplId, "/schedule"), scheduleData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.saveScheduleSettings = saveScheduleSettings;
function getEmployeeSubmitted(eplId) {
    return api_1.default.get("".concat(base, "/").concat(eplId, "/employee-submitted")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getEmployeeSubmitted = getEmployeeSubmitted;
function getHiddenExperiences(eplId) {
    return api_1.default.get("".concat(base, "/").concat(eplId, "/hidden-experiences")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getHiddenExperiences = getHiddenExperiences;
function getHiddenExperienceFields(eplId) {
    return api_1.default.get("".concat(base, "/").concat(eplId, "/hidden-experience-fields")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getHiddenExperienceFields = getHiddenExperienceFields;
function getZoomRecordingCount(eplId) {
    return api_1.default.get("/api/zoom-recording/count-by-epl/".concat(eplId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getZoomRecordingCount = getZoomRecordingCount;
/**
 * Invokes workflow to process the audio recording and produce
 * a whisper generated transcript for Atheneum Intelligence
 * @param {number} eplId
 * @param {number} projectId
 * @returns 202 if the sync process was invoked accepted successfully
 * @error in case of bad request
 */
function invokeAISync(eplId, projectId) {
    return api_1.default.post("/api/zoom-recording/sync/".concat(eplId), { projectId: projectId }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.invokeAISync = invokeAISync;
function remove(eplId) {
    return api_1.default
        .delete('/api/expert-project-link/' + eplId)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.remove = remove;
/**
 * Returns all the EPL statuses and possible transitions
 */
function getEplStatuses() {
    return api_1.default.get('/api/epl-status').then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getEplStatuses = getEplStatuses;
function getExternLink(eplId, isEplExtract) {
    var url = "/api/expert-project-link/".concat(eplId, "/extern-link");
    if (isEplExtract) {
        url = "".concat(url, "?isEplExtract=true");
    }
    return api_1.default.post(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getExternLink = getExternLink;
function getExternLinks(eplId) {
    return api_1.default.post("/api/expert-project-link/".concat(eplId, "/extern-links")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getExternLinks = getExternLinks;
function inviteToProject(eplId, data) {
    return api_1.default.post("/api/expert-project-link/".concat(eplId, "/invite-to-project"), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.inviteToProject = inviteToProject;
function bulkCreate(eplsData) {
    return api_1.default.post('/api/expert-project-link/bulk-create', eplsData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.bulkCreate = bulkCreate;
function bulkValidate(data) {
    return api_1.default.post('/api/expert-project-link/bulk-validate', data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.bulkValidate = bulkValidate;
function bulkInvite(data) {
    return api_1.default.post('/api/expert-project-link/bulk-invite-to-project', data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.bulkInvite = bulkInvite;
/**
 * Calls the Zoom api and upserts zoomRecordings for a certain epl. Caution: api is rate-limited at 10 req/sec.
 *
 * @param {string} eplId
 */
function fetchRecordingsFromEplId(eplId) {
    var endpoint = "/api/zoom-recording/lookup/".concat(eplId);
    return api_1.default.post(endpoint).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.fetchRecordingsFromEplId = fetchRecordingsFromEplId;
function getRecordingsFromEplHash(eplHash) {
    var endpoint = "/api/recording/extern/".concat(eplHash);
    return api_1.default.get(endpoint).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getRecordingsFromEplHash = getRecordingsFromEplHash;
function getRecordingsFromEplId(eplId) {
    var endpoint = "/api/recording/from-epl-id/".concat(eplId);
    return api_1.default.get(endpoint).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getRecordingsFromEplId = getRecordingsFromEplId;
function rearchiveRecording(scheduleId) {
    var endpoint = "/api/zoom-recording/rearchive";
    return api_1.default.post(endpoint, { scheduleId: scheduleId }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.rearchiveRecording = rearchiveRecording;
function setSegmentForEpls(segmentId, eplIds) {
    var endpoint = "/api/segment/".concat(segmentId, "/expert-project-link");
    return api_1.default
        .put(endpoint, {
        eplIds: eplIds,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.setSegmentForEpls = setSegmentForEpls;
function setStatusForEpls(eplStatusId, eplIds) {
    var endpoint = "/api/expert-project-link/status/".concat(eplStatusId);
    return api_1.default
        .put(endpoint, {
        eplIds: eplIds,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.setStatusForEpls = setStatusForEpls;
function getLoggedEvents(eventType, eplId) {
    return api_1.default
        .post('/api/logged-event/query', { eventType: eventType, eventIds: [eplId] })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getLoggedEvents = getLoggedEvents;
function recalculateMargin(_a) {
    var fee = _a.fee, honorarium = _a.honorarium, feeCurrencyId = _a.feeCurrencyId, honorariumCurrencyId = _a.honorariumCurrencyId;
    return api_1.default
        .post('/api/expert-project-link/margin', {
        fee: fee,
        honorarium: honorarium,
        feeCurrencyId: feeCurrencyId,
        honorariumCurrencyId: honorariumCurrencyId,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.recalculateMargin = recalculateMargin;
function sendExtractEplEmail(data) {
    return api_1.default.post('/api/expert-project-link/send-extract-epls-email', data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendExtractEplEmail = sendExtractEplEmail;
function sendGo30Email(data) {
    return api_1.default.post('/api/expert-project-link/send-go30-email', data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendGo30Email = sendGo30Email;
function sendRejectionEmail(eplId, projectId) {
    return api_1.default
        .post("/api/expert-project-link/".concat(eplId, "/send-rejection-email"), {
        projectId: projectId,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.sendRejectionEmail = sendRejectionEmail;
function convertCurrency(_a) {
    var amount = _a.amount, fromCurrencyId = _a.fromCurrencyId, toCurrencyId = _a.toCurrencyId;
    return api_1.default
        .post('/api/expert-project-link/convert-fee-currency', {
        amount: amount,
        fromCurrencyId: fromCurrencyId,
        toCurrencyId: toCurrencyId,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.convertCurrency = convertCurrency;
function createFollowUpEpl(eplId, status) {
    return api_1.default
        .post("/api/expert-project-link/create-capi-follow-up-epl", {
        eplId: eplId,
        status: status,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.createFollowUpEpl = createFollowUpEpl;
function updateEpl(eplId, data) {
    return api_1.default
        .put('/api/expert-project-link/' + eplId, data)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateEpl = updateEpl;
function sendIndividualLink(projectId, userId) {
    if (userId === void 0) { userId = null; }
    return api_1.default
        .post("/api/expert-project-link/".concat(projectId, "/individual-link"), { userId: userId })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.sendIndividualLink = sendIndividualLink;
function sendGenericLinks(projectId) {
    return api_1.default.post("/api/expert-project-link/".concat(projectId, "/generic-link")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendGenericLinks = sendGenericLinks;
function saveHCPAdditionalInfo(eplId, data) {
    return api_1.default.post("/api/expert-project-link/".concat(eplId, "/hcpAdditionalInfo"), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.saveHCPAdditionalInfo = saveHCPAdditionalInfo;
function getHCPAdditionalInfo(eplId) {
    return api_1.default.get("/api/expert-project-link/".concat(eplId, "/hcpAdditionalInfo")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getHCPAdditionalInfo = getHCPAdditionalInfo;
function updateScreeningV2Responses(_a) {
    var eplId = _a.eplId, expertId = _a.expertId, segmentId = _a.segmentId, _b = _a.answers, answers = _b === void 0 ? [] : _b, associateComment = _a.associateComment, _c = _a.responseQuestions, responseQuestions = _c === void 0 ? [] : _c, isCommentVisible = _a.isCommentVisible;
    return api_1.default
        .post("".concat(base, "/").concat(eplId, "/screening-responses"), JSON.stringify({ segmentId: segmentId, expertId: expertId, answers: answers, associateComment: associateComment, responseQuestions: responseQuestions, isCommentVisible: isCommentVisible }), { headers: { 'Content-Type': 'application/json' } })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateScreeningV2Responses = updateScreeningV2Responses;
function getScreeningAnswersHtml(_a) {
    var eplId = _a.eplId, segmentId = _a.segmentId;
    return api_1.default
        .get("".concat(base, "/").concat(eplId, "/screening-responses-html?segmentId=").concat(segmentId))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getScreeningAnswersHtml = getScreeningAnswersHtml;
function updateGo30Information(_a) {
    var eplId = _a.eplId, relevantExperienceId = _a.relevantExperienceId, additionalExperienceId = _a.additionalExperienceId, industryExpertise = _a.industryExpertise, hiddenExperienceIds = _a.hiddenExperienceIds, _b = _a.experiencesHiddenToExpert, experiencesHiddenToExpert = _b === void 0 ? null : _b, _c = _a.goxLabel, goxLabel = _c === void 0 ? '' : _c;
    return api_1.default
        .put("".concat(base, "/").concat(eplId, "/go30"), {
        relevantExperienceId: relevantExperienceId,
        additionalExperienceId: additionalExperienceId,
        industryExpertise: industryExpertise,
        hiddenExperienceIds: hiddenExperienceIds,
        experiencesHiddenToExpert: experiencesHiddenToExpert,
        goxLabel: goxLabel,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateGo30Information = updateGo30Information;
function bcgExpertSubmit(data, skipPlatform) {
    if (skipPlatform === void 0) { skipPlatform = false; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var queryString, url;
        return tslib_1.__generator(this, function (_a) {
            queryString = "?skipPlatform=".concat(skipPlatform);
            url = "".concat(process.env.REACT_APP_BCG_TRANSFORMER_URL, "/expert/submit").concat(queryString);
            return [2 /*return*/, api_1.default
                    .post(url, data)
                    .then(api_1.extractData)
                    .catch(api_1.errorHandler)];
        });
    });
}
exports.bcgExpertSubmit = bcgExpertSubmit;
function bcgExpertStatus(data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url;
        return tslib_1.__generator(this, function (_a) {
            url = "".concat(process.env.REACT_APP_BCG_TRANSFORMER_URL, "/expert/status");
            return [2 /*return*/, api_1.default
                    .put(url, data)
                    .then(api_1.extractData)
                    .catch(api_1.errorHandler)];
        });
    });
}
exports.bcgExpertStatus = bcgExpertStatus;
var api = {
    get: get,
    save: save,
    autosave: autosave,
    remove: remove,
    updateDeliveredBy: updateDeliveredBy,
    saveScheduleSettings: saveScheduleSettings,
    getEmployeeSubmitted: getEmployeeSubmitted,
    getHiddenExperiences: getHiddenExperiences,
    getHiddenExperienceFields: getHiddenExperienceFields,
    getEplStatuses: getEplStatuses,
    getZoomRecordingCount: getZoomRecordingCount,
    fetchRecordingsFromEplId: fetchRecordingsFromEplId,
    getRecordingsFromEplHash: getRecordingsFromEplHash,
    getRecordingsFromEplId: getRecordingsFromEplId,
    rearchiveRecording: rearchiveRecording,
    inviteToProject: inviteToProject,
    bulkCreate: bulkCreate,
    bulkValidate: bulkValidate,
    bulkInvite: bulkInvite,
    recalculateMargin: recalculateMargin,
    setSegmentForEpls: setSegmentForEpls,
    getLoggedEvents: getLoggedEvents,
    getExternLink: getExternLink,
    getExternLinks: getExternLinks,
    sendExtractEplEmail: sendExtractEplEmail,
    sendRejectionEmail: sendRejectionEmail,
    convertCurrency: convertCurrency,
    createFollowUpEpl: createFollowUpEpl,
    updateEpl: updateEpl,
    sendIndividualLink: sendIndividualLink,
    sendGenericLinks: sendGenericLinks,
    getHCPAdditionalInfo: getHCPAdditionalInfo,
    updateScreeningV2Responses: updateScreeningV2Responses,
    bcgExpertSubmit: bcgExpertSubmit,
    bcgExpertStatus: bcgExpertStatus,
};
exports.default = api;
